import { render, staticRenderFns } from "./KeyNine.vue?vue&type=template&id=8255ce24&"
import script from "./KeyNine.vue?vue&type=script&lang=js&"
export * from "./KeyNine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports